import { render, staticRenderFns } from "./EWUserActivityLimitLogList.vue?vue&type=template&id=7852b920&"
import script from "./EWUserActivityLimitLogList.vue?vue&type=script&lang=js&"
export * from "./EWUserActivityLimitLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports